import React, { useCallback } from 'react';
import RadioGroupAdapter from '../../adapters/radioAdapter';
import type { EntityNextEventDropDownProps } from './types';

function EntityNextEventDropDown({
  code: entityNextEventDropDownCode,
  value,
  disabled,
  onChange,
  placeholder,
  showDisabledIcon,
  loading,
  customPayload,
  viewMode = false,
  ...props
}: EntityNextEventDropDownProps & {
  loading: boolean;
}) {
  const matchedOption = (customPayload?.entityNextEventOptions || []).find(
    (option) => option.code === value,
  );
  const resolvedValue = matchedOption?.value || matchedOption?.code;

  const onChangeEntityNextEventDropDown = useCallback(
    (selectedOptions, event) => {
      const { code } = selectedOptions[0];
      onChange(code, event, { data: { code } });
    },
    [onChange],
  );

  return (
    <RadioGroupAdapter
      value={resolvedValue}
      disabled={disabled}
      onChange={onChangeEntityNextEventDropDown}
      meta={{ viewType: 'chipRadio', placeholder }}
      loading={loading}
      viewMode={viewMode}
      showDisabledIcon={showDisabledIcon}
      {...props}
      // @ts-ignore
      options={customPayload.entityNextEventOptions || []}
    />
  );
}

export default EntityNextEventDropDown;
